import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useLoggedInUserRoles } from '~/components/Auth';
import { NavigationLevelPathConfig } from '~/components/Sidebar/components/SidebarMenuLevel';
import { useAppModules } from '~/scenes/AppModules/useAppModules';
import { AppModules, isRoleHRAdmin } from '~/services/Permissions';

export const useAdminViews = () => {
  const { t } = useTranslation();
  const userRoles = useLoggedInUserRoles();
  const userHasAccess = isRoleHRAdmin(userRoles);

  const { isModuleActive } = useAppModules();

  const navigationStructure: NavigationLevelPathConfig[] = useMemo(() => {
    return [
      {
        path: 'people',
        label: t('laPeople'),
        subPaths: [
          {
            path: 'custom-translations',
            label: t('customTranslations'),
          },
        ],
      },
      {
        path: 'common',
        label: t('laCommon'),
        subPaths: [
          {
            path: 'homepage-settings',
            label: t('homePageSettings'),
          },
          {
            path: 'branding-settings',
            label: t('portalBrandingSetting'),
            isAvailable: isModuleActive(AppModules.BRANDING),
          },
        ],
      },
      {
        path: 'workflow',
        label: t('laWorkFlow'),
        subPaths: [
          {
            path: 'workflow',
            label: t('laWorkFlow'),
            isLegacy: true,
          },
          {
            path: 'workflow2',
            label: `${t('laWorkFlow')} 2.0`,
          },
        ],
      },
    ];
  }, [t, isModuleActive]);

  return {
    navigationStructure,
    userHasAccess,
  };
};
